import {
  splashScreenOpenRequested,
  unassignUserFromBreakoutRoomRequested,
} from 'features/breakout-rooms/actions';
import { UserId } from 'features/users/types';
import { selectLocalUserId } from 'features/users/usersSlice';
import { put, select } from 'redux-saga/effects';
import { selectRoomId } from 'features/room/roomSlice';

export function* onLeaveBreakoutRoomRequestedSaga() {
  const userId: UserId = yield select(selectLocalUserId);
  const roomId: string = yield select(selectRoomId);

  yield put(
    unassignUserFromBreakoutRoomRequested({
      id: roomId,
      userId,
    })
  );
  yield put(splashScreenOpenRequested('leaving'));
}
